import React, { useEffect, useContext, useRef } from "react";
import { Redirect, useHistory } from "react-router-dom";
import Bus from "@/utils/bus";
import GlobalContext from "@/context/GlobalContext";
import { isFocusEnv } from "@/utils";
import { get } from "lodash";
import { convertEmployeeToString, sleep } from "@/utils/chat/message";
import config, { ConfigEnum } from "@/config/config";
const localUrl = new URL(location.href);
const loadSess = localUrl.searchParams.get("loadSess"); // 1
const pageName = localUrl.searchParams.get("page");
const isHomePage = !pageName && !localUrl.pathname.includes("VideoViewer");

/**
 * 顺次重定向
 */
export default () => {
  const { appRuntimeEnv, service, authInfo } = useContext(GlobalContext);
  const openAppRef = useRef<boolean>(false);
  const history = useHistory();

  const handleGetApp = async (appkey: string) => {
    if (!service) {
      return false;
    }
    await sleep(2000);
    try {
      history.push("/third_apps");
      const appInfo: any = await service.appStoreService.getApplication({ applicationKey: appkey });
      if (!appInfo?.application) {
        return false;
      }
      Bus.emit("openThirdApp", appInfo?.application);
    } catch (e) {
      return false;
    }
    openAppRef.current = true;
    return true;
  };

  useEffect(() => {
    // 这一块需要重新处理  在这里处理逻辑
    // 判断打开应用
    if (!openAppRef.current && isHomePage && isFocusEnv()) {
      const appInfo = get(
        appRuntimeEnv?.registryConfig?.settings,
        `autoOpen[${authInfo?.userId}:${authInfo?.ddAppId}:${authInfo?.selectedTeamId}]`
      );
      if (appInfo?.applicationKey) {
        handleGetApp(appInfo?.applicationKey).then((res) => {});
        return;
      }
    }
    history.push(config[ConfigEnum.LEFT_SIDE_PAGE_INDEX] ? "/homePage" : "/messages");

  }, [history]);

  return null;
};
